module.exports = __webpack_public_path__ + "static/media/ms.058b028b.svg";